import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import { Redemption } from "./types/Redemption";

export const redemptionFragment = gql`
  fragment RedemptionFragment on Redemption {
    id
    name
    description
    minOrderAmount
    enable
    maxRedemptionAmount
    signText
  }
`;

export const redemptionDetailsFragment = gql`
  ${redemptionFragment}
  fragment RedemptionDetailsFragment on Redemption {
    ...RedemptionFragment
    redemptionVariants {
      id
      sortOrder
      discountPrice
      variant {
        id
        name
        sku
        skuName
        isPublished
        product {
          id
          name
        }
        thumbnail {
          url
        }
      }
    }
  }
`;

const redemption = gql`
  ${redemptionDetailsFragment}
  query Redemption {
    redemption {
      ...RedemptionDetailsFragment
    }
  }
`;

export const useRedemptionQuery = makeQuery<Redemption, null>(redemption);
